import { z } from 'zod';

export const reReframeVerticalsRequestSchema = z.object({
  collectionId: z.number().int().positive().optional(),
  cursor: z.string().optional(),
  limit: z.number().int().positive().optional(),
  // 'missing' (default): only clips with no vertical yet (fills the gap fast).
  // 'all': re-reframe every clip with a base master (full letterbox re-pass, the whole library).
  mode: z.enum(['missing', 'all']).default('missing'),
});

// Input type so callers can omit fields with a server-side default (e.g. `mode`).
export type IReReframeVerticalsRequest = z.input<typeof reReframeVerticalsRequestSchema>;
